<template>
  <div class="bg-white bb pt-10">
    <div class="top-header">
      <el-row class="container" :gutter="24">
        <el-col :span="12">
          <Header-user />
        </el-col>
        <el-col :span="12">
          <header-search />
        </el-col>
      </el-row>
    </div>
    <div v-if="!hide" class="bottom-header container">
      <header-menu />
    </div>
  </div>
</template>

<script>
import HeaderMenu from '@/components/Header/HeaderMenu'
import HeaderSearch from '@/components/Header/HeaderSearch'
import HeaderUser from '@/components/Header/Header_user'

export default {
  name: 'Header',
  components: {
    HeaderMenu,
    HeaderSearch,
    HeaderUser,
  },
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.filLibs()
  },
}
</script>

<style lang="sass">
.bg-white
    background-color: #fff

.pt-10
    padding-top: 10px

.bb
  border-bottom: 1px solid #cccccc

.top-header
  margin-top: 20px
</style>
